export const messages = {
  en: {
    aStaffCommunity: {
      orgPlaceholder: 'Select organization',
      staffPlaceholder: 'Enter staff name',
      linkCommunity: 'Link Community',
      staffName: 'Staff Name',
      staffId: 'Staff ID',
      communityId: 'Community ID',
      communityName: 'Community Name',
      selectStaffFirst: 'Please select a staff first'
    }
  },
  zh: {
    aStaffCommunity: {
      orgPlaceholder: '选择组织',
      staffPlaceholder: '填写员工名称',
      linkCommunity: '关联园区',
      staffName: '员工名称',
      staffId: '员工编号',
      communityId: '园区编号',
      communityName: '园区名称',
      selectStaffFirst: '请先选择员工'
    }
  }
}